export function openCart($this, response) {
    if ($this.$isDesktop(true) && response?.cart?.url) {
        $this.$store.dispatch('showPopupWithUrl', response.cart.url);
    } else if (response.popup_content || response?.prompt_json?.popup_content) {
        $this.$store.dispatch('showPopup', response.popup_content || response?.prompt_json?.popup_content);
    }
}
